import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy-900 border-t border-navy-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">

          {/* Brand */}
          <div>
            <div className="mb-5">
              <img
                src="/dtx_header.svg"
                alt="DTX Digital Transformation"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              A 100% Woman-Owned, SBA 8(a) Certified small business delivering Facilities Management and
              Information Technology solutions to the federal government.
            </p>
            <div className="flex flex-wrap gap-2">
              {['SBA 8(a)', 'EDWOSB', 'WOSB'].map((cert) => (
                <span
                  key={cert}
                  className="text-xs border border-gold-500/40 text-gold-500 px-2.5 py-1 rounded-full font-semibold"
                >
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">Quick Links</h4>
            <div className="space-y-2.5">
              {[
                { to: '/', label: 'Home' },
                { to: '/services/facilities', label: 'Facilities Management' },
                { to: '/services/it', label: 'IT Services' },
                { to: '/about/leadership-team', label: 'Leadership Team' },
                { to: '/about/capability-statement', label: 'Capability Statement' },
                { to: '/about/naics-codes', label: 'NAICS Codes' },
                { to: '/contact', label: 'Contact Us' },
              ].map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="block text-slate-400 hover:text-gold-400 text-sm transition-colors"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">Contact</h4>
            <div className="space-y-4 text-sm">
              <div>
                <p className="text-slate-500 text-xs uppercase tracking-wider mb-1">Address</p>
                <p className="text-slate-400">43661 Catton Pl<br />Ashburn, VA 20147</p>
              </div>
              <div>
                <p className="text-slate-500 text-xs uppercase tracking-wider mb-1">Email</p>
                <a
                  href="mailto:contact@dtxdigitaltransformation.com"
                  className="text-slate-400 hover:text-gold-400 transition-colors break-all"
                >
                  contact@dtxdigitaltransformation.com
                </a>
              </div>
              <div>
                <p className="text-slate-500 text-xs uppercase tracking-wider mb-1">SAM.gov UEI</p>
                <p className="text-slate-400 font-mono">ESNGY5HK7QS1</p>
              </div>
              <div>
                <p className="text-slate-500 text-xs uppercase tracking-wider mb-1">CAGE Code</p>
                <p className="text-slate-400 font-mono">64GE5</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-navy-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © 2026 DTX Digital Transformation, LLC. All rights reserved.
          </p>
          <a
            href="https://dtxdigitaltransformation.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 opacity-40 hover:opacity-75 transition-opacity group"
            title="Visit our previous website"
          >
            <img
              src="/First_DTX_Logo.jpg"
              alt="DTX Digital Transformation (previous site)"
              className="h-8 w-auto rounded-sm"
            />
            <span className="text-slate-600 text-xs group-hover:text-slate-400 transition-colors">
              Previous site
            </span>
          </a>
          <p className="text-slate-600 text-xs tracking-wide">
            SBA 8(a) &nbsp;·&nbsp; EDWOSB &nbsp;·&nbsp; WOSB &nbsp;·&nbsp; SAM Registered &nbsp;·&nbsp; Ashburn, VA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
